import React from "react";

// scontrino row item -----------------------------------
const LabelLabelRow = ({ label, value }) => {
  return (
    <div className="flex flex-row justify-between items-center py-1 text-md ">
      <div className="flex flex-row items-center gap-x-1">
        <span className={`${"text-gray-400"}`}>{label}</span>
      </div>
      <span className={`${"text-gray-400"} whitespace-nowrap`}>{value}</span>
    </div>
  );
};

export default LabelLabelRow;
